// extracted by mini-css-extract-plugin
export default {"wrap":"zG-z","fullWidth":"AG-z","hideOnDesktop":"BG-z","content":"CG-z","hasOpenedNav":"DG-z","crumbsList":"EG-z","dropdownsWrap":"FG-z"};